import script from "./APIAndIntegrations.vue?vue&type=script&setup=true&lang=js"
export * from "./APIAndIntegrations.vue?vue&type=script&setup=true&lang=js"

import "./APIAndIntegrations.vue?vue&type=style&index=0&id=f3b3e4a6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3b3e4a6"]])

export default __exports__